const YOUTUBE_REGEX = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
const VIMEO_REGEX = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
const GENIALLY_REGEX = /^(https?:\/\/view\.(genially\.com|genial\.ly)\/[\w\-]+)/;

/**
 * Detecta o tipo de player a partir da URL da aula (uso do wizard CreateLesson).
 * youtube/vimeo → videoId é o id do vídeo; genially → videoId é a própria URL casada.
 */
export function getLessonPlayerType(url) {
  if (!url) return { player: null, videoId: null };

  const youtubeResult = url.match(YOUTUBE_REGEX);
  if (youtubeResult) return { player: 'youtube', videoId: youtubeResult[6] };

  const vimeoResult = url.match(VIMEO_REGEX);
  if (vimeoResult) return { player: 'vimeo', videoId: vimeoResult[4] };

  const geniallyResult = url.match(GENIALLY_REGEX);
  if (geniallyResult) return { player: 'genially', videoId: geniallyResult[0] };

  return { player: null, videoId: null };
}

export default getLessonPlayerType;
